// pages/Oati/OattNetworkRatesPage.tsx
import OattRatesPage from './OattRates';

const OattNetworkRatesPage = () => <OattRatesPage pageType="network" />;

export default OattNetworkRatesPage;
